const errorIfChecked = value => !value;

export default errorIfChecked;
